var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNumber1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.676 28h-5.483V17.418c0-1.285.028-2.461.082-3.527-.337.41-.756.838-1.257 1.285l-2.27 1.873-2.803-3.445 6.864-5.592h4.867V28z",
    fill: "#fff",
    fillOpacity: 0.2
  })));
}

export default SvgNumber1;